import { render, staticRenderFns } from "./DialogConfirmSalesProducts.vue?vue&type=template&id=b86a6d04&scoped=true"
import script from "./DialogConfirmSalesProducts.vue?vue&type=script&lang=js"
export * from "./DialogConfirmSalesProducts.vue?vue&type=script&lang=js"
import style0 from "./DialogConfirmSalesProducts.vue?vue&type=style&index=0&id=b86a6d04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b86a6d04",
  null
  
)

export default component.exports